// src/services/api/businessAPI.js

const FIREBASE_FUNCTIONS_BASE_URL = process.env.REACT_APP_FIREBASE_FUNCTIONS_BASE_URL;

export class BusinessAPI {
  /**
   * Resolve business slug to business details
   * @param {string} businessSlug - Business slug from URL
   * @returns {Promise<Object>} Business context
   */
  static async resolveBusinessSlug(businessSlug) {
    try {
      console.log('API: Resolving business slug', { businessSlug });

      if (!businessSlug) {
        throw new Error('Business slug is required');
      }

      const url = `${FIREBASE_FUNCTIONS_BASE_URL}/business/api/resolve/${businessSlug}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Business not found');
        }
        throw new Error(`API Error: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to resolve business');
      }

      console.log('API: Successfully resolved business', {
        businessSlug,
        businessName: result.data.businessName,
        userId: result.data.userId
      });

      return result.data;

    } catch (error) {
      console.error('API Error in resolveBusinessSlug:', {
        businessSlug,
        error: error.message
      });
      throw new Error(`Failed to resolve business: ${error.message}`);
    }
  }
}